import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import axios from 'axios';

import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

function postCheckEmailAPI(paramDatas) {
  return axios({
    method: 'post',
    url: apiUrl + 'PasswdReset',
    data: paramDatas
  });
}

export const CheckPasswdEmailAPI = params => common.requestRaw(execUrl + 'PasswdMail', params, 'get');

// function putPasswdResetAPI(paramDatas) {
//   return axios({
//     method: 'put',
//     url: apiUrl + 'PasswdReset',
//     data: paramDatas
//   });
// }

// action types
const INITIAL_STORE = 'passwdReset/INITIAL_STORE';
const POST_CHECKEMAIL = 'passwdReset/POST_CHECKEMAIL';
const GET_CHECKPASSWDEMAIL = 'passwdReset/GET_CHECKPASSWDEMAIL';
// const PUT_PASSWDRESET = 'passwdReset/PUT_PASSWDRESET';
const CHANGE_INPUT = 'passwdReset/CHANGE_INPUT';
const MOVE_PASSWD_RESET = 'passwdReset/MOVE_PASSWD_RESET';
const INIT_PASSWDRESET = 'passwdReset/INIT_PASSWDRESET';
const INIT_PASSWDRESET_MAIL = 'passwdReset/INIT_PASSWDRESET_MAIL';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const postCheckEmail = createAction(POST_CHECKEMAIL, postCheckEmailAPI);
export const getCheckPasswdEmail = createAction(GET_CHECKPASSWDEMAIL, CheckPasswdEmailAPI);
// export const putPasswdReset = createAction(PUT_PASSWDRESET, putPasswdResetAPI);
export const changeInput = createAction(CHANGE_INPUT);
export const movePasswdReset = createAction(MOVE_PASSWD_RESET);
export const initPasswdReset = createAction(INIT_PASSWDRESET);
export const initPasswdResetMail = createAction(INIT_PASSWDRESET_MAIL);

const initialState = Map({
  step: 1,
  // 메일 발송(확인)
  send: Map({
    isExist: 0, // 0-초기값(미체크), 1-존재, 2-존재하지 않음
    isSend: 0 // 0-초기값(미발송), 1-성공, 2-실패
  }),
  isReSend: 0, // 0-초기값
  // 재설정
  reset: Map({
    isReset: 0, //
    isValid: 0
  }),
  form: Map({
    userEmail: '',
    userPasswd: ''
  }),
  userEmail: ''
});

export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    ...pender({
      //type: POST_CHECKEMAIL,
      type: GET_CHECKPASSWDEMAIL,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        return list.isExist === 1 ? state.set('send', Map(list)).set('step', 2) : state.set('send', Map(list));
      },
      onFailure: (state, action) => {
        console.log('이메일 체크 실패');
      }
    }),
    [CHANGE_INPUT]: (state, action) => {
      const { name, value } = action.payload;
      return state.setIn(['form', name], value);
    },
    [MOVE_PASSWD_RESET]: (state, action) => {
      return state.set('step', 3);
    },
    [INIT_PASSWDRESET]: (state, action) => {
      return state
        .set('send', initialState.get('send'))
        .set('reset', initialState.get('reset'))
        .set('form', initialState.get('form'))
        .set('step', 1);
    },
    [INIT_PASSWDRESET_MAIL]: (state, action) => {
      return state.set('isReSend', 1);
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/pwReset.js